'use client'

import { ReactSelectMenu } from '@repo/ui/ReactSelectMenu'
import { useEffect, useState } from 'react'
import { useLookupsStore } from '@repo/store/useLookupsStore'
import PropTypes from 'prop-types'

export const ExpertTypeSelect = ({
  testData = null,
  value = null,
  onChange = (val) => {
    console.log(val)
  },
  sx = {},
  size = 'small',
  required,
  errors = {}
}) => {
  const { fetchExpertTypes, expertTypes } = useLookupsStore()
  const [options, setOptions] = useState(testData || expertTypes || [])
  const [selectedValue, setSelectedValue] = useState(value)

  useEffect(() => {
    if (testData) return
    setOptions(expertTypes || [])
  }, [testData, expertTypes])

  useEffect(() => {
    if (testData || expertTypes?.length) return
    fetchExpertTypes()
  }, [testData, expertTypes, fetchExpertTypes])

  useEffect(() => {
    setSelectedValue(value)
  }, [value])

  return (
    <div data-testid="ExpertTypeSelect" style={{ width: sx?.width || '100%', maxWidth: sx?.maxWidth || '100%', ...sx }}>
      <ReactSelectMenu
        label="Expert type"
        onChange={(newVal) => {
          onChange(newVal)
          setSelectedValue(newVal)
        }}
        labelKey="description"
        valueKey="expertTypeId"
        items={options}
        value={selectedValue}
        searchable
        idLabelKey="expertTypeId"
        showIdInResults={false}
        name="expertTypeId"
        size={size}
        required={required}
        errors={errors}
        menuZindex={9999999}
      />
    </div>
  )
}

ExpertTypeSelect.propTypes = {
  testData: PropTypes.array,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.number]),
  onChange: PropTypes.func,
  sx: PropTypes.object,
  size: PropTypes.string,
  required: PropTypes.bool,
  errors: PropTypes.object
}
